<template>
  <div class="container">
    <van-cell title="宝塔" is-link to="index" />
    <van-cell title="关于售后" is-link to="/user/afterSales" />
  </div>
</template>

<script>
export default {
  name: "order",
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 5px 0;
  height: 100vh;
  background: #e8e8e8;
  box-sizing: border-box;
}
</style>
